import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'dataPhotoSrc'
})
export class DataPhotoSrcPipe implements PipeTransform {

    transform(value: string): string {
        return !value ? '' : "data:image/jpeg;base64," + value;
    } // transform()

} // DataPhotoSrcPipe
